export const ORDERED_GROUPED_STRUCTURE_KEY = 'ORDERED_GROUPED_STRUCTURE'
export const ORDERED_GROUPED_STRUCTURE_HASH_KEY = 'ORDERED_GROUPED_STRUCTURE_HASH'
export const HEADER_NO_DUPLICATE_WIDTH_THRESHOLD = 60
export const HEADER_SPECIAL_CASE_KEY = 'HEADER_SPECIAL_CASE'
export const HORIZONTAL_STACK_WIDTH_THRESHOLD = 200
